/* src/views/jour/proto/JourIncidentsProto.jsx — L'ÉCRAN INCIDENTS d'Aujourd'hui,
   transcrit de docs/handoff/aujourdhui-complet.jsx (JourIncidents). LE DESSIN,
   PAS LA LOGIQUE : nav de mois, trois stats, le bloc terracotta « non
   récupérables » (jugés par l'orchestrateur — à vous de décider qui paie),
   le groupement Par date / Par logement, les filtres comptés, les groupes
   navy et leurs lignes. Styles copiés tels quels ; data-testid ajoutés. */

import React from 'react'
import { NavMoisJour, StatsTrio, EnTeteGroupe } from './JourChrome'

/* Le pictogramme d'état d'une ligne : ? terra (à trancher), € ambre (à
   racheter), ✓ vert (réglé), ♻ ciel (récupérable) — les quatre du fichier. */
const PICTOS = {
  trancher: { g: '?', fond: '#b8412b' },
  racheter: { g: '€', fond: '#d98c1f' },
  regle: { g: '✓', fond: '#2f9e6e' },
  recup: { g: '♻', fond: '#87b8e6' },
}
const TAGS = {
  trancher: { cl: 'tag t-t', lb: 'à trancher' },
  racheter: { cl: 'tag t-a', lb: 'à racheter' },
  regle: { cl: 'tag t-v', lb: 'réglé' },
  recup: { cl: 'tag t-b', lb: 'récupérable' },
}

export function LigneIncident({ etat, taille = 30, titre, sous, onOuvrir, testId,
  bordTerra, premiere }) {
  const p = PICTOS[etat] || PICTOS.regle
  const t = TAGS[etat] || TAGS.regle
  return (
    <button onClick={onOuvrir} data-testid={testId}
      style={bordTerra
        ? { display: 'flex', alignItems: 'center', gap: '10px', width: '100%',
            textAlign: 'left', background: '#fff', border: '1px solid var(--terra-bd)',
            borderRadius: '11px', padding: '9px 11px', minHeight: '54px' }
        : { display: 'flex', alignItems: 'center', gap: '10px', width: '100%',
            textAlign: 'left', background: '#fff', border: 'none', padding: '10px 12px',
            minHeight: '56px',
            ...(premiere ? {} : { borderTop: '1px solid var(--bord)' }) }}>
      <span style={{ width: `${bordTerra ? 32 : 30}px`, height: `${bordTerra ? 32 : 30}px`,
        borderRadius: `${bordTerra ? 9 : 8}px`, background: p.fond, color: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: `${bordTerra ? 15 : 14}px`, fontWeight: '600',
        flexShrink: '0' }}>{p.g}</span>
      <span style={{ flex: '1', minWidth: '0' }}>
        <span style={{ display: 'block', fontSize: '12.5px', fontWeight: '600',
          color: 'var(--navy-d)' }}>{titre}</span>
        <span style={{ display: 'block', fontSize: '10.5px', color: 'var(--gris)',
          marginTop: '1px', overflow: 'hidden', textOverflow: 'ellipsis',
          whiteSpace: 'nowrap' }}>{sous}</span>
      </span>
      <span className={t.cl}>{t.lb}</span>
      {bordTerra && <span style={{ fontSize: '15px', color: 'var(--gris-d)',
        flexShrink: '0' }}>›</span>}
    </button>
  )
}

export function JourIncidentsProto({ mois, stats, aDecider, groupement, onGroupe,
  filtres, filtreActif, onFiltre, groupes, note }) {
  return (
    <div className="page">
      <NavMoisJour testId="incidents-mois" label={mois.label} n={mois.n}
        onPrec={mois.onPrec} onSuiv={mois.onSuiv} suivActif={mois.suivActif} />
      <StatsTrio items={[
        { n: stats.enCours, lb: 'En cours', fond: '#b8412b' },
        { n: stats.regles, lb: 'Réglés', fond: '#2f9e6e' },
        { n: stats.recuperes, lb: 'Récupérés', fond: '#87b8e6' },
      ]} />
      {aDecider && aDecider.lignes.length > 0 && (
        <div data-testid="incidents-a-decider" style={{ background: 'var(--terra-bg)',
          border: '1px solid var(--terra-bd)', borderRadius: '14px', padding: '12px 13px',
          marginBottom: '14px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '9px',
            marginBottom: '10px' }}>
            <span style={{ width: '28px', height: '28px', borderRadius: '8px',
              background: '#b8412b', color: '#fff', display: 'flex', alignItems: 'center',
              justifyContent: 'center', fontSize: '14px', flexShrink: '0' }}>⚠</span>
            <span style={{ flex: '1', minWidth: '0' }}>
              <span style={{ display: 'block', fontSize: '13px', fontWeight: '600',
                color: 'var(--terra-tx)' }}>{aDecider.titre}</span>
              <span style={{ display: 'block', fontSize: '10.5px', color: 'var(--terra-tx)',
                opacity: '.8' }}>{aDecider.sous}</span>
            </span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
            {aDecider.lignes.map((l, i) => (
              <LigneIncident key={i} bordTerra etat={l.etat} titre={l.titre}
                sous={l.sous} onOuvrir={l.onOuvrir} testId={l.testId} />
            ))}
          </div>
        </div>
      )}
      <div style={{ display: 'flex', alignItems: 'center', gap: '3px',
        background: '#eef2f6', borderRadius: '10px', padding: '3px', marginBottom: '11px',
        width: 'fit-content' }}>
        <button onClick={() => onGroupe('date')} data-testid="incidents-par-date"
          style={groupement === 'date'
            ? { minHeight: '36px', padding: '0 14px', borderRadius: '8px', fontSize: '12px',
                whiteSpace: 'nowrap', background: '#fff', color: 'var(--navy-d)',
                fontWeight: '600', boxShadow: '0 1px 3px rgba(35,50,64,.12)' }
            : { minHeight: '36px', padding: '0 14px', borderRadius: '8px', fontSize: '12px',
                whiteSpace: 'nowrap', color: 'var(--gris)' }}>Par date</button>
        <button onClick={() => onGroupe('log')} data-testid="incidents-par-logement"
          style={groupement === 'log'
            ? { minHeight: '36px', padding: '0 14px', borderRadius: '8px', fontSize: '12px',
                whiteSpace: 'nowrap', background: '#fff', color: 'var(--navy-d)',
                fontWeight: '600', boxShadow: '0 1px 3px rgba(35,50,64,.12)' }
            : { minHeight: '36px', padding: '0 14px', borderRadius: '8px', fontSize: '12px',
                whiteSpace: 'nowrap', color: 'var(--gris)' }}>Par logement</button>
      </div>
      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '12px' }}>
        {filtres.map((f) => {
          const on = filtreActif === f.id
          return (
            <button key={f.id} onClick={() => onFiltre(f.id)}
              data-testid={`incidents-filtre-${f.id}`}
              style={on
                ? { display: 'inline-flex', alignItems: 'center', gap: '7px',
                    minHeight: '38px', padding: '0 12px', borderRadius: '10px',
                    border: '1px solid #3d5166', background: '#3d5166', fontSize: '11.5px',
                    fontWeight: '600', color: '#fff' }
                : { display: 'inline-flex', alignItems: 'center', gap: '7px',
                    minHeight: '38px', padding: '0 12px', borderRadius: '10px',
                    border: '1px solid #d5e3ee', background: '#fff', fontSize: '11.5px',
                    fontWeight: '400', color: 'var(--gris)' }}>{f.lb}
              <span style={on
                ? { minWidth: '18px', height: '18px', borderRadius: '9px',
                    background: 'rgba(255,255,255,.22)', color: '#fff', display: 'inline-flex',
                    alignItems: 'center', justifyContent: 'center', fontSize: '10px',
                    fontWeight: '600', padding: '0 5px' }
                : { minWidth: '18px', height: '18px', borderRadius: '9px',
                    background: '#eef2f6', color: 'var(--gris-d)', display: 'inline-flex',
                    alignItems: 'center', justifyContent: 'center', fontSize: '10px',
                    fontWeight: '600', padding: '0 5px' }}>{f.n}</span>
            </button>
          )
        })}
      </div>
      {groupes.map((g, gi) => (
        <div className="carte" key={gi}
          style={{ margin: '0 0 9px', padding: '0', overflow: 'hidden' }}>
          <EnTeteGroupe titre={g.titre} sous={g.sous} />
          {g.lignes.map((l, i) => (
            <LigneIncident key={i} premiere={i === 0} etat={l.etat} titre={l.titre}
              sous={l.sous} onOuvrir={l.onOuvrir} testId={l.testId} />
          ))}
        </div>
      ))}
      <p className="note">{note}</p>
    </div>
  )
}
